import { render, staticRenderFns } from "./AutoTradingSignalPage.vue?vue&type=template&id=129a352c&scoped=true"
import script from "./AutoTradingSignalPage.vue?vue&type=script&lang=js"
export * from "./AutoTradingSignalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a352c",
  null
  
)

export default component.exports